<template>
  <div class="auto-resolution-details">
    <div v-if="autoResolutionDetails.length">
      <div
        v-for="(property, index) in autoResolutionDetails"
        :key="property.charge_type"
        class="auto-resolution-details__container">
        <accordian
          :expanded="property.expanded"
          :item="property"
          :index="index"
          @onCardToggle="onAccordianToggle">
          <div
            slot="accordian-header-content"
            class="auto-resolution-details__container__accordian-header">
            <div
              class="auto-resolution-details__container__accordian-header__content">
              {{
                property.charge_type?.replaceAll(
                  "[Manual Charge]",
                  " - Manual Charge"
                )
              }}
            </div>
          </div>
          <div
            v-if="property.expanded"
            slot="accordian-body"
            class="auto-resolution-details__container__accordian-body">
            <div
              v-for="item in property?.decision === 'Manual Charge'
                ? manualAutoResolutionDetailsMapping
                : property?.decision === 'Potential Reject'
                ? formAutoResolutionDetailsMapping
                : autoResolutionDetailsConstant"
              :key="item.label"
              class="auto-resolution-details__container__accordian-body__item">
              <template
                v-if="
                  item.slotKey === 'surcharge-emails'
                    ? property['qsr_mails']?.length
                    : item.slotKey === 'surcharge-sfdc-emails'
                    ? property['sfdc_mails']?.length
                    : true
                ">
                <span
                  class="auto-resolution-details__container__accordian-body__item--title">
                  {{ item.label }}:
                </span>
                <span
                  v-if="
                    item.slotKey === 'surcharge-emails' ||
                    item.slotKey === 'surcharge-sfdc-emails'
                  "
                  class="auto-resolution-details__container__accordian-body__item--mailid"
                  @click="
                    $emit(
                      'redirectToSurchargeTab',
                      item.slotKey === 'surcharge-emails'
                        ? property['qsr_mails']
                        : property['sfdc_mails'],
                      `${
                        item.slotKey === 'surcharge-emails'
                          ? 'qsr-emails'
                          : 'sfdc-emails'
                      }`
                    )
                  ">
                  {{ getValue(property, item.slotKey) }}
                </span>
                <span
                  v-else-if="item.slotKey === 'justification'"
                  class="auto-resolution-details__container__accordian-body__item--value"
                  v-html="
                    replaceNewLineWithBr(getValue(property, item.slotKey))
                  ">
                </span>
                <span
                  v-else
                  class="auto-resolution-details__container__accordian-body__item--value">
                  {{ getValue(property, item.slotKey) }}
                </span>
              </template>
            </div>
          </div>
        </accordian>
      </div>
    </div>
    <div v-else>Auto resolution data is not present</div>
  </div>
</template>

<script>
import {
  autoResolutionDetailsConstant,
  autoResolutionConstantData,
  getAutoResolutionForJustification,
  manualAutoResolutionDetailsMapping,
} from "@/config/disputeDataConstant.js";
import { replaceNewLineWithBr } from "@/utils/helpers";

export default {
  name: "AutoResolutionDetails",
  props: {
    autoResolutionDetails: {
      type: Array,
      default() {
        return [];
      },
    },
    category: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      autoResolutionDetailsConstant: autoResolutionDetailsConstant,
      manualAutoResolutionDetailsMapping: manualAutoResolutionDetailsMapping,
      autoResolutionConstantData,
      getAutoResolutionForJustification,
    };
  },
  computed: {
    formAutoResolutionDetailsMapping() {
      return this.autoResolutionDetailsConstant?.filter(
        (item) => item?.slotKey !== "type"
      );
    },
  },
  methods: {
    replaceNewLineWithBr,
    onAccordianToggle(data, index) {
      event.stopPropagation();
      console.log(data);
      let newArray = [...this.autoResolutionDetails];
      newArray[index] = {
        ...data,
        expanded: !data.expanded,
      };
      this.autoResolutionDetails = newArray;
    },
    getJustificationContent(justification, catgory) {
      return `WHAT IS THE CUSTOMER ISSUE ABOUT?\n ${catgory} \n\n ${justification}`;
    },
    getValue(property, slotKey) {
      let chargeType = property.charge_type;
      if (slotKey === "justification" && !property[slotKey]) {
        return this.getJustificationContent(
          this.getAutoResolutionForJustification[chargeType][
            property.algo_type ? property.algo_type : "default"
          ],
          this.category
        );
      } else if (
        slotKey === "surcharge-emails" ||
        slotKey === "surcharge-sfdc-emails"
      ) {
        return "Click to view E-Mails";
      } else if (slotKey === "charge_type") {
        return (
          property[slotKey]?.replaceAll("[Manual Charge]", "") ||
          this.autoResolutionConstantData[slotKey]?.replaceAll(
            "[Manual Charge]",
            ""
          )
        );
      }

      return property[slotKey] || this.autoResolutionConstantData[slotKey];
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.auto-resolution-details {
  &__container {
    cursor: pointer;
    position: relative;
    margin-bottom: 16px;
    &__accordian-header {
      display: flex;
      align-items: center;
      &__content {
        display: flex;
        align-items: center;

        @include media("<tablet") {
          flex-direction: column;
        }
      }
    }

    &__accordian-body {
      padding: 1rem;
      border: 1px solid var(--Gray-200);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: flex;
      flex-direction: column;
      margin-left: 0;
      cursor: default;

      @include media("<tablet") {
        margin-left: 40px;
      }

      &__item {
        display: flex;
        margin-bottom: 8px;
        &--title {
          color: var(--Gray-600);
          display: flex;
          flex-direction: column;
          flex-basis: 100%;
          flex: 1;
        }
        &--value {
          display: flex;
          flex-direction: column;
          flex-basis: 100%;
          flex: 1;
          flex: 2;
          word-break: break-all;
        }
        &--mailid {
          color: rgb(0, 0, 238);
          cursor: pointer;
          display: flex;
          flex-direction: column;
          flex-basis: 100%;
          flex: 1;
          flex: 2;
          word-break: break-all;
        }
      }
    }
  }
  .accordian__header {
    margin-left: 0;
  }
}
</style>
